const Lvideos = [
    {"value":"https://www.youtube.com/watch?v=q0BVR5jRXxE&t=758s"},
    {"value":"https://www.youtube.com/watch?v=zNBNhKQf2b4" }, 
    {"value":"https://www.youtube.com/watch?v=32Hfatl5tnY"},
    {"value":"https://www.youtube.com/watch?v=_Or4pg-N58M"},
    {"value":"https://www.youtube.com/watch?v=f4umx1ZpYhw"},
    {"value":"https://www.youtube.com/watch?v=2FsycyeSdYI"},
    {"value":"https://www.youtube.com/watch?v=mJW57E7GpSo"},
    {"value":"https://www.youtube.com/watch?v=3Os1buMUXOk"},
    {"value":"https://www.youtube.com/watch?v=uu5Be_EY73s"},
    {"value":"https://www.youtube.com/watch?v=fwcn7D18u8Q"},
    {"value":"https://www.youtube.com/watch?v=NpnSiwjgQIA"},
    {"value":"https://www.youtube.com/watch?v=nh3sr6b2sD4"},
    {"value":"https://www.youtube.com/watch?v=d0rvkGQDWEU"},
    {"value":"https://www.youtube.com/watch?v=dVRwwrsIlIE"},
    {"value":"https://www.youtube.com/watch?v=3YoPBO66W_A"},
    {"value":"https://www.youtube.com/watch?v=dkDUYgiMP-o"}
    

]

export default Lvideos;